// Skills.jsx
import { useState, useEffect } from 'react';
import FrontEnd from './FrontEnd';
import BackEnd from './BackEnd';
import Databases from './Databases';
import Tools from './Tools';
import './Skills.css';

const Skills = () => {
  const [activeTab, setActiveTab] = useState('frontend');
  const [isVisible, setIsVisible] = useState(false);

  const tabs = [
    { id: 'frontend', label: 'Frontend', icon: 'bx bxl-react', color: '#61DAFB' },
    { id: 'backend', label: 'Backend', icon: 'bx bxl-nodejs', color: '#68A063' },
    { id: 'databases', label: 'Databases', icon: 'bx bxs-data', color: '#FF6B6B' },
    { id: 'tools', label: 'Tools', icon: 'bx bx-wrench', color: '#4ECDC4' },
  ];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case 'frontend':
        return <FrontEnd />;
      case 'backend':
        return <BackEnd />;
      case 'databases':
        return <Databases />;
      case 'tools':
        return <Tools />;
      default:
        return <FrontEnd />;
    }
  };

  return (
    <section className="skills section" id="skills">
      <div className="skills__header">
        <h2 className="section__title">Technical Skills</h2>
        <p className="section__subtitle">Technologies I work with</p>
        <div className="skills__divider"></div>
      </div>

      <div className="skills__tabs-container container">
        {tabs.map((tab, index) => (
          <div
            key={tab.id}
            className={`skills__tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            style={{
              '--tab-color': tab.color,
              animationDelay: `${index * 0.1}s`
            }}
          >
            <div className="skills__tab-icon">
              <i className={tab.icon}></i>
            </div>
            <span className="skills__tab-label">{tab.label}</span>
            <div className="skills__tab-indicator"></div>
          </div>
        ))}
      </div>

      <div className={`skills__content-container container ${isVisible ? 'visible' : ''}`}>
        {renderContent()}
      </div>
    </section>
  );
};

export default Skills;